<template>
  <div style="padding: 14px;">
    <div class="div-screen">
      <div class="div-row">
        <span class="span-lable">客户名称：</span>
        <el-select v-model="customerIds" placeholder="请选择客户名称" size="small" filterable class="mr-24" multiple collapse-tags style="width:300px;" @change="getCallRecord" :filter-method="filterMethod1">
          <el-option v-for="(item,index) in customerNamesList" :key="index" :label="item.name" :value="item.id" />
        </el-select>
        <span class="span-lable">联系人：</span>
        <el-select v-model="contactIds" placeholder="请选择联系人" size="small" filterable class="" multiple collapse-tags style="width:300px;" @change="getCallRecord" :filter-method="filterMethod">
          <el-option v-for="(item,index) in contactNamesList" :key="index" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="div-row">
        <span class="span-lable">状态：</span>
        <span class="span-option" :class="item.value === status ? 'is-select' : ' '" v-for="(item,index) in stateList" :key="index" @click="clickState(item.value)">{{ item.name }}</span>
      </div>
    </div>
    <div class="div-table">
      <el-table :data="tableData" :header-cell-style="{color:'#333'}">
        <el-table-column prop="callOutName" label="客户名称" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.callOutName||'--'}}</template>
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.contactName||'--'}}</template>
        </el-table-column>
        <el-table-column prop="customerNumber" label="手机号码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ownerName" label="归属人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callTime" label="拨打时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="拨打状态">
          <template slot-scope="scope">
            <play-status :type="scope.row.status == 3 ? 'success':'error'">{{ scope.row.status == 3 ? '已接通':'未接通' }}</play-status>
          </template>
        </el-table-column>
        <el-table-column prop="bridgeDurationFormat" label="通话时长"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==3" type="text" @click="clickOpen(scope.row)">语音聊天</el-button>
            <!-- <el-button v-if="scope.row.source!=5&&scope.row.source!=10" type="text" @click="clickDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.source==10" type="text" @click="clickDetail1(scope.row)">详情</el-button> -->
            <!-- <el-button v-if="scope.row.source==5" type="text" @click="clickTracking(scope.row)">通话追踪</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination :page-num="pageNum" :page-size="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" style="margin-top:60px;" />
    </div>
    <el-dialog title="聊天录音" :visible.sync="dialogVisible" width="720px" :before-close="handleCloseDialog" class="audio-dialog">
      <el-row class="audio-wrap">
        <el-col :span="12">
          <p class="grayText">客户名称：<span class="darkText">{{currentRecord.callOutName||'--'}}</span></p>
          <p class="grayText">手机号码：<span class="darkText">{{currentRecord.customerNumber||'--'}}</span></p>
          <p class="grayText">拨打状态： <play-status v-if="currentRecord.status==3" type="success">已接通</play-status>
            <play-status v-else type="error">未接通</play-status>
          </p>
        </el-col>
        <el-col :span="12">
          <p class="grayText">联系人：<span class="darkText">{{currentRecord.contactName||'--'}}</span></p>
          <p class="grayText flex">归属人：
            <el-tooltip class="item" effect="dark" :content="currentRecord.ownerName" placement="top-end">
              <span class="darkText ellipsis">{{currentRecord.ownerName||'--'}}</span>
            </el-tooltip>
          </p>
          <p class="grayText">通话时长：<span style="color:#374FB8">{{currentRecord.bridgeDurationFormat}}</span></p>
        </el-col>
      </el-row>
      <audioPlay ref="audioPlay" :uniqueId="currentRecord.requestUniqueId" :key="currentRecord.requestUniqueId" />
    </el-dialog>
    <!-- 名单详情 -->
    <!-- <detail ref="detail" @getData="loadData"/> -->
    <detail ref="detail"/>
  </div>
</template>
<script>
import audioPlay from '@/components/audioPlay'
import pagination from '@/components/pagination'
import PlayStatus from '../component/PlayStatus'
import detail from '../component/detail'
import { getCallRecord, getContactNameByLike, getCustomerNameByLike, tracking } from '../api'
import '@/assets/text/text.css'

export default {
  components: {
    PlayStatus, detail, pagination, audioPlay
  },
  data () {
    return {
      currentRecord: {},
      dialogVisible: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      headData: {},
      status: '0',
      stateList: [{ name: '全部', value: '0' }, { name: '已接通', value: '1' }, { name: '未接通', value: '2' }],
      customerIds: [],
      customerNamesList: [],
      customerNamesLists: [],
      arr1: [],
      contactIds: [],
      contactNamesList: [],
      contactNamesLists: [],
      arr: [],
      tableData: []
    }
  },
  mounted () {
    this.getCallRecord()
    this.getContactNameByLike()
    this.getCustomerNameByLike()
  },
  methods: {
    clickDetail1 (row) {
      var data = {
        id: row.leadId
      }
      if (row.leadId) {
        this.$refs.detail.openDrawer(data)
      }
    },
    filterMethod1 (query) {
      // 获取选中的list
      this.customerNamesLists.forEach((val, i) => {
        this.customerIds.forEach(id => {
          if (val.id.indexOf(id) != -1) {
            this.arr1.push(val)
            this.customerNamesLists.splice(i, 1)
          }
        })
      })
      this.arr1.forEach((e, i) => {
        var index = this.customerIds.indexOf(e.id)
        if (index === -1) {
          this.arr1.splice(i, 1)
        }
      })
      var idnex = (100 - this.arr1.length) // 默认选择100条减去选中的条数
      if (query == '') { this.customerNamesList = this.arr1.concat(this.customerNamesLists.slice(0, idnex)) } // 合并选中的条数加上截取的list共计100条
      else {
        const result = []
        this.customerNamesLists.forEach(val => {
          if (val.name.indexOf(query) != -1) result.push(val)
        })
        this.customerNamesList = this.arr1.concat(result.slice(0, idnex)) // 合并选中的条数加上截取的list共计100条
      }
    },
    filterMethod (query) {
      // 获取选中的list
      this.contactNamesLists.forEach((val, i) => {
        this.contactIds.forEach(id => {
          if (val.id.indexOf(id) != -1) {
            this.arr.push(val)
            this.contactNamesLists.splice(i, 1)
          }
        })
      })
      this.arr.forEach((e, i) => {
        var index = this.contactIds.indexOf(e.id)
        if (index === -1) {
          this.arr.splice(i, 1)
        }
      })
      var idnex = (100 - this.arr.length) // 默认选择100条减去选中的条数
      if (query == '') { this.contactNamesList = this.arr.concat(this.contactNamesLists.slice(0, idnex)) } // 合并选中的条数加上截取的list共计100条
      else {
        const result = []
        this.contactNamesLists.forEach(val => {
          if (val.name.indexOf(query) != -1) result.push(val)
        })
        this.contactNamesList = this.arr.concat(result.slice(0, idnex)) // 合并选中的条数加上截取的list共计100条
      }
    },
    clickOpen (row) {
      this.dialogVisible = true
      this.currentRecord = row
    },
    handleCloseDialog () {
      this.dialogVisible = false
      if (!this.$refs.audioPlay.isPaused) return
      this.$refs.audioPlay.playAudio()
    },
    clickTracking (row) {
      tracking({ id: row.id }).then(res => {
        // 呼叫来源  1:线索 2：联系人 3：客户 4：商机
        if (res.data.source === 1) {
          this.$router.push({ path: '/customerManage/opportunities/clue/clueDetail', query: { id: res.data.id } })
        } else if (res.data.source === 2) {
          this.$router.push({ path: '/customerManage/customer/contacts/detail', query: { id: res.data.id } })
        } else if (res.data.source === 3) {
          this.$router.push({ path: '/customerManage/customer/list/customerDetailNew', query: { id: res.data.id } })
        } else if (res.data.source === 4) {
          this.$router.push({ path: '/customerManage/opportunities/businessOpp/viewDetail', query: { id: res.data.id } })
        } else if (res.data.source === 5) {
          this.$router.push({ path: '/customerManage/opportunities/clue/clueEdit', query: { customerNumber: row.customerNumber } })
        }
      })
    },
    clickDetail (row) {
      // 呼叫来源 0.线索 1.客户 2.商机 3.联系人呼叫
      // 最新1:线索 2：联系人 3：客户 4：商机
      if (row.source === 1) {
        this.$router.push({ path: '/customerManage/opportunities/clue/clueDetail', query: { id: row.leadId } })
      } else if (row.source === 2) {
        this.$router.push({ path: '/customerManage/customer/contacts/detail', query: { id: row.contactId } })
      } else if (row.source === 3) {
        this.$router.push({ path: '/customerManage/customer/list/customerDetailNew', query: { id: row.customerId } })
      } else if (row.source === 4) {
        this.$router.push({ path: '/customerManage/opportunities/businessOpp/viewDetail', query: { id: row.businessId } })
      }
    },
    getContactNameByLike () { // 联系人
      getContactNameByLike({}).then(res => {
        this.contactNamesLists = res.data
        this.contactNamesList = res.data.slice(0, 100)
      })
    },
    getCustomerNameByLike () { // 客户名字
      getCustomerNameByLike({}).then(res => {
        this.customerNamesLists = res.data
        this.customerNamesList = res.data.slice(0, 100)
      })
    },
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.getCallRecord()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.getCallRecord()
    },
    getCallRecord () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        callBeginDate: this.$route.query.callDate,
        callEndDate: this.$route.query.callDate,
        contactIds: this.contactIds,
        customerIds: this.customerIds,
        status: this.status
      }
      getCallRecord(data).then(res => {
        this.tableData = this.Global.transformEmptyObject(res.data.list)
        this.total = Number(res.data.total)
      })
    },
    clickState (val) {
      this.status = val
      this.pageNum = 1
      this.getCallRecord()
    }
  }
}
</script>
<style lang="scss" scoped>
.audio-dialog {
  /deep/ .el-dialog__body {
    padding: 30px 24px;
    border-top: 1px solid #e5e5e5;
  }
  .audio-wrap {
    margin-bottom: 20px;
    p {
      padding: 10px 0;
      font-size: 12px;
    }
    span {
      font-size: 14px;
    }
    .ellipsis{
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex: 1;
      cursor: pointer;
    }
  }
}
.a-btn {
  display: inline-block;
  width: 66px;
  height: 32px;
  border: 1px solid #e4e6e8;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  color: #666;
  font-size: 12px;
}
.div-table {
  margin-top: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
}
.div-screen {
  margin-bottom: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .div-row {
    height: 32px;
    line-height: 32px;
    position: relative;
    /deep/ .el-select__tags .el-tag {
      max-width: 150px !important;
    }
    /deep/ .el-select .el-select__tags > span {
      display: contents !important;
    }
    /deep/ .el-select .el-select__tags > span .el-tag__close.el-icon-close {
      right: -1px;
      top: 3px;
    }
  }
  .div-row + .div-row {
    margin-top: 12px;
  }
  .span-lable {
    display: inline-block;
    text-align: right;
    width: 60px;
    color: #666;
    font-size: 12px;
    margin-right: 8px;
  }
  .input-with-select /deep/ .el-input-group__append {
    width: 32px;
    background: #374fb8;
    padding: 0 10px;
    border-color: #374fb8;
  }
  .a-btn {
    position: relative;
    top: 1px;
    display: inline-block;
    width: 66px;
    height: 32px;
    border: 1px solid #e4e6e8;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    color: #666;
    font-size: 12px;
    img {
      position: relative;
      top: 3px;
    }
  }
  .span-option {
    font-size: 12px;
    color: #666;
    cursor: pointer;
  }
  .span-option:hover {
    color: #374fb8;
    font-size: 14px;
  }
  .span-option + .span-option {
    margin-left: 32px;
  }
  .is-select {
    font-size: 14px;
    color: #374fb8;
  }
}
</style>
